<template>
  <section id="mass-unsuspend" class="text-center">
    <h3>You are about to mass-unsuspend the below tariffs</h3>
    <div v-if="!confirming" class="btn btn-primary" @click="confirming = true">
      Confirm mass-unsuspension
    </div>
    <div v-if="confirming">
      <h5>
        Are you sure?
      </h5>  
      <div class="btn btn-success" @click="update">
        Confirm
      </div>
      <div class="btn btn-danger" @click="confirming = false">
        Cancel
      </div>
    </div>
  </section>
</template>
<script>
  export default {
    name: 'MassUnsuspend',
    data () {
      return {
        confirming: false
      }
    },
    methods: {
      update () {
        this.confirming = false
        this.$emit('unsuspend')
      }
    }
  }
</script>
<style>
  #mass-unsuspend {
    padding: 10px 10px 30px 10px;
    background-color: #eee;
    margin: 0 10px;
    -webkit-box-shadow: 0px 0px 10px 2px rgba(68,68,68,0.82);
    -moz-box-shadow: 0px 0px 10px 2px rgba(68,68,68,0.82);
    box-shadow: 0px 0px 10px 2px rgba(68,68,68,0.82);
    transition: all 0.5s;
  }
  #mass-unsuspend:hover {
    -webkit-box-shadow: 0px 0px 20px 5px rgba(68,68,68,0.82);
    -moz-box-shadow: 0px 0px 20px 5px rgba(68,68,68,0.82);
    box-shadow: 0px 0px 20px 5px rgba(68,68,68,0.82);
  }
</style>



// WEBPACK FOOTER //
// src/modules/admin/components/Tariff/MassUnsuspend.vue